angular.module('cvsApp').service('getCarrierTrackingDetailsService',
    ['networkService', 'xdrService', 'configManager', 'getCarrierTrackingDetailsModel','cvsAppData', function (NS, XS,CM, GCTD,CAD) {

        function getCarrierTrackingDetails (){
            this.getCarrierTrackingDetailsData = function(shipmentNumber, trackingNumber,carrierName,callBackSuccess){
                //get url
                var tokenId= CAD.getTokenId();
                var tokenType= CAD.getTokenType();
                var apikey = CAD.getApiKey();
                var url = CVS.Config.serviceHost[cvsUtility.queryMap.env]+"SPLAGPv1/order/getCarrierTrackingDetails/v2"
                if(cvsUtility.queryMap.env === 'local'){
				url = CVS.Config.serviceHost[cvsUtility.queryMap.env] +"specialty/SPLAGPv1/order/getCarrierTrackingDetails/v2";
    			}
                if(url === "URL_ERROR"){

                }else{
                    //url = url.replace('/getCarrierTrackingDetails', '/getCarrierTrackingDetails_'+shipmentNumber);
                    //var url = cvsUtility.updateQueryParam(url, 'appName', 'Portal');
                    var request = {url:url,
                        header:{
                            Accept: 'application/json'
                        },
                        data:requestBody(trackingNumber,carrierName),
                        onSuccess:callBackSuccess
                    }
					/*if (cvsUtility.getIEVersion() <= 9) {
					 XS.makeRequest(url, "", xdrSuccess);

					 function xdrSuccess (data) {
					 GCTD.setResponse(data);
					 callBackSuccess(OSM.getResponse());
					 }
					 }
					 else {
					 var promise = NS.post(request);
					 return promise
					 }*/
                    cvsUtility.commonServiceCode(url,"getCarrierTrackingDetails",GCTD,request,callBackSuccess,NS);
                }

            }


            var requestBody = function(trackingNumber,carrierName){

                var tokenId =  CAD.getTokenId();
                var tokenType = CAD.getTokenType();
                var apikey = CAD.getApiKey();
                return {"getCarrierTrackingDetailsRequest": {
                    "header":    {
                        "serviceContext":       {
                            "appName": cvsUtility.queryMap.mobileAppStyle? 'SPL_APP' : 'SPL_WEB',
                            "lineOfBusiness": "Specialty",
                            "channelName": cvsUtility.queryMap.channel,
                            "responseFormat": "JSON",      
                            "tokenID": tokenId,
                            "tokenType": CM.getAGPTokenType(tokenType),
                            //"tokenType": tokenType,
                            "type":"SPLSBMS",
					        "bkAppName":"orderService"

                        },
                        "securityContext": {
                            "apiKey": apikey,
                            "securityType": "apiKey"
                        }
                    },
                    "details": {"trackshipment":    {
                        "carrierName": carrierName,
                        "trackingNumber": trackingNumber
                    }}
                }}


            }

        }

        return new getCarrierTrackingDetails();
    }]);
